import { lazy, Suspense } from 'react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './index.css';
import Privacy from './pages/privacy';
import Terms from './pages/terms';
import Play from './pages/play';
import Quiz from './pages/quiz';

import Leaderboard from './pages/leaderboard';
import Result from './pages/result';

const Start = lazy(() => import('./pages/start'));
const Download = lazy(() => import('./pages/download'));

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/">
          <Route index element={<Start />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="terms" element={<Terms />} />
          <Route path="play" element={<Play />} />
          <Route path="quiz" element={<Quiz />} />
          <Route path="game" element={<Quiz />} />
          <Route path="download" element={<Download />} />
          <Route path="ranking" element={<Leaderboard />} />
          <Route path="result" element={<Result />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

